import { Box, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { selectLanguage, selectTranslations } from 'state/reducers/translation.reducers';
import ProfileEdit from './ProfileEdit';
import UserInfoCard from './UserInfoCard';
import { FormInputsTypes } from 'constants/settings.constants';
import { Tooltip } from 'theme/elements/Tooltip';
import { setEditSuccess, setEditMode, setMessage, isLoading } from 'state/reducers/settings.reducers';
import { store } from 'state/store';
import { getMobile, togglePage } from 'state/reducers/ui.reducers';
import { pagesEnum } from 'constants/ui.constants';
import { getExistingContacts } from 'state/reducers/contact.reducers';
import { getUserDetails, getUserPermission } from 'state/reducers/user.reducers';
import WaitingMessage from 'components/WaitingMessage';

export default function MyProfile() {
  const dispatch = useAppDispatch();
  const t = useAppSelector(selectTranslations);
  const [dataToEdit, setDataToEdit] = useState(FormInputsTypes.NAME);
  const editSuccess = useAppSelector(state => state.settings.editSuccess)
  const editMode = useAppSelector(state => state.settings.editMode)
  const isMobile = useAppSelector(getMobile);
  const prefixFields = 'page.settings.my_profile.';
  const contacts = useAppSelector(getExistingContacts);
  const userADInfo = useAppSelector(getUserDetails);
  const contactLanguage = useAppSelector(selectLanguage);
  const contactPermission = useAppSelector(getUserPermission);
  const loading = useAppSelector(isLoading);

  useEffect(() => {
    dispatch(setEditSuccess(false));
  }, []);

  const userDetails = useMemo(() => {
    const userData = contacts?.filter((item: any) => item.email === userADInfo.email);
    return userData[0];
  }, [contacts]);

  const handleEdit = (clickedElement: any) => {
    setDataToEdit(clickedElement.type);
    if (isMobile) {
      dispatch(togglePage('/' + pagesEnum.SETTINGS + '/editProfile/' + clickedElement.type));
    } else {
      dispatch(setEditMode(true));
    }
  };

  return (
    <>
      <Box sx={{ position: 'relative' }}>
        {loading ? (
          <WaitingMessage />
        ) : (
          <>
            {editSuccess && (
              <Tooltip
                dismissLabel={t(prefixFields + 'tooltip.dismiss_button.text')}
                handleClick={() => dispatch(setEditSuccess(false))}
                styleObj={{ top: '1%', left: '50%', transform: 'translate(-50%, -50%)' }}
              >
                <Typography> {t(prefixFields + 'success_tooltip.text')}</Typography>
              </Tooltip>
            )}
            {editMode && (
              <ProfileEdit
                dataToEdit={dataToEdit}
                userDetails={userDetails}
                handleCancelEdit={() => {
                  dispatch(setEditMode(false));
                  dispatch(setMessage({ exist: false }));
                }}
              />
            )}
            {!editMode && (
              <UserInfoCard
                handleEdit={handleEdit}
                contactLanguage={contactLanguage}
                contactPermission={contactPermission}
                userDetails={userDetails}
                userADInfo={userADInfo}
              />
            )}
          </>
        )}
      </Box>
    </>
  );
}
